import React from 'react';
import FormControlLabelMui, { FormControlLabelProps } from '@material-ui/core/FormControlLabel';

export const FormControlLabel: React.FC<FormControlLabelProps> = ({ children, ...rest }) => {
	return <FormControlLabelMui {...rest}>{children}</FormControlLabelMui>;
};
